import Common from "../common/Common";

class Pagenav2 {
  constructor() {
    this.common = new Common();
    this.mediaQueryList = this.common.matchMedia("md");
    this.header = document.querySelector(".l-header");
    this.pagenav2 = document.querySelector(".js-pagenav2");
    this.pagenav2Area = document.querySelector(".js-pagenav2Area");

    this.initialize();
  }

  initialize() {
    this.mediaQueryList.addEventListener("change", this.resize.bind(this));

    if( this.pagenav2 ) {
      this.fixed1()
    }

  }

  // ウィンドウサイズ変更時の処理
  resize() {
    if (this.mediaQueryList.matches) {
      // SPサイズになった時の処理
    } else {
      // PCサイズになった時の処理
    }
  }

  fixed1() {
    const header = this.header;
    const headerH = header.offsetHeight;
    const target = this.pagenav2;
    const area = this.pagenav2Area;
    const targetH = target.offsetHeight;

    // initialize
    target.style.height = targetH + "px";
    area.style.position = "relative";
    const links = target.querySelectorAll(".c-pagenav2__link1");

    links.forEach((link) => {
      const hash = link.getAttribute("href");
      const id = hash.replace( /#/g , "" );
      const nav = document.querySelector(".c-pagenav3[data-nav=" + id + "]");
      let clone = nav.cloneNode(true);
      clone.classList.remove('js-pagenav3');
      link.after(clone);
    });

    window.addEventListener("scroll", () => {
      // fix
      let startPos = target.getBoundingClientRect().top;
      const areaH = area.clientHeight;
      const targetM = target.offsetTop;
      let endPos = startPos + areaH - targetM;

      if( !header.classList.contains('is-hidden') ) {
        startPos = startPos - headerH;
        endPos = endPos - headerH;
      }

      if( 0 > startPos + targetH && 0 < endPos) {
        target.classList.add('is-mdFixed1');
      } else if( 0 < startPos ) {
        target.classList.remove('is-mdFixed1');
      } else {
        target.classList.remove('is-mdFixed1');
      }

      // current
      let currentFrag = false;
      links.forEach((link) => {
        const hash = link.getAttribute("href");
        const anchor = document.querySelector(hash);
        const anchorArea = anchor.closest('.c-smAccordion1');
        const anchorAreaH = anchorArea.clientHeight;
        let anchorStartPos = anchor.getBoundingClientRect().top;
        let anchorEndPos = anchorStartPos + anchorAreaH;
        const pagenav = 59 + 53;

        if( !header.classList.contains('is-hidden') || header.classList.contains('is-show') ) {
          anchorStartPos = anchorStartPos - headerH;
          anchorEndPos = anchorEndPos - headerH;
        }

        if( 1 > anchorStartPos - pagenav -1 && 1 < anchorEndPos - pagenav - 1) {
          link.classList.add('is-current1');
          currentFrag = true;
        } else if( 1 < anchorStartPos - pagenav ) {
          link.classList.remove('is-current1');
        } else {
          link.classList.remove('is-current1');
        }
      });

      if ( !currentFrag ) {
        target.classList.remove('is-mdFixed1');
      //  const first = target.querySelector(".c-pagenav2__item1:first-child .c-pagenav2__link1");
      //  first.classList.add('is-current1');
      }
    });
  }
}

export default Pagenav2;